import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';
import { ShieldAlert, ArrowLeft } from 'lucide-react';

const Blocked = () => {
    const navigate = useNavigate();
    const referenceId = useMemo(() => Math.random().toString(36).substring(2, 10).toUpperCase(), []);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
            <div className="text-center max-w-lg bg-background p-8 flex flex-col items-center">
                <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 animate-pulse">
                    <ShieldAlert size={40} className="text-red-500" />
                </div>

                <h1 className="text-2xl font-bold text-slate-900 mb-3">Account Blocked</h1>

                <div className="bg-red-50 text-red-700 px-5 py-3.5 rounded-2xl mb-6 flex items-start gap-3 text-left">
                    <p className="text-sm leading-relaxed">
                        Your account has been blocked from the application. This typically happens due to a violation of our terms of service or suspicious activity.
                    </p>
                </div>

                <p className="text-slate-600 mb-8 text-base">
                    If you believe this is a mistake, please email us at{' '}
                    <a 
                        href="mailto:contact@prepxai.in" 
                        className="text-primary hover:underline font-medium transition-all"
                    >
                        contact@prepxai.in
                    </a>{' '}
                    for assistance.
                </p>

                <div className="flex justify-center w-full">
                    <Button
                        variant="default"
                        className="flex items-center justify-center gap-2 py-2.5 px-6 rounded-xl font-semibold transition-all w-full sm:w-auto text-sm"
                        onClick={() => navigate('/')}
                    >
                        <ArrowLeft size={16} />
                        Back to Home
                    </Button>
                </div>

                {/* <div className="mt-10 pt-6 border-t border-slate-100 w-full">
                    <p className="text-xs text-slate-400">
                        Reference ID: {referenceId}
                    </p>
                </div> */}
            </div>
        </div>
    );
};

export default Blocked;



